import './index.less'
import React from 'react'
import { Dropdown, Menu } from 'antd'
import { get } from '../../../yx-widget/utils'
import { YxText } from 'yx-widget'
import { YxComponent, Connection} from '../../../yx-widget/component/YxComponent'

const IconFont = YxText.Icon;
/**
* YxCard，卡片组
* @param extra String/Node 下拉按钮前面的节点，可接受string类型和Node类型数据
* @param text String/Node 下拉按钮的内容，可接受string类型和Node类型数据
* @param isClickClose bool 是否选中菜单时关闭菜单，默认为false
* @param unClosekeys array 包含的菜单的key值，如果包含选的菜单时不关闭菜单弹窗，当isClickClose存在并且为true时生效
* @param content  Node 下拉弹窗的内容，接收来自antd的Menu组件，Menu组件内容自定义
* @param inputParam Object 接收antd下拉组件的的原参数
*/

let defaultProps = () => {
    return {
        extra: '', // 下拉按钮前面的节点，可接受string类型和Node类型数据
        text: '',// 下拉按钮的内容，可接受string类型和Node类型数据
        content: '',// 下拉弹窗的内容，接收来自antd的Menu组件，Menu组件内容自定义
        inputParam: {}, // 接收antd 下拉组件的的原参数
    }
 }
@Connection(defaultProps)
    export default class extends YxComponent {
    constructor(props, context) {
        super(props, context)
        this.state = {
            visible: false
        }
    }


    // 获取父组件传来的参数值
    getDropIcon(item){
        let ele = get(this.props,item,'')
        return ele;
    }

    // 渲染按钮元素
    renderConent(){
        let text = get(this.props,"text",'按钮')
        let { visible } = this.state;
        return <div className={`yx_yxDropdown`}>
            {this.getDropIcon('extra')}  {/* 获取按钮前的元素 节点元素 */}
            <span className={`yx-dropdown-btn-text ${visible ? 'yx-dropdown-btn-text-active': ''}`}>{text}</span>   {/* 获取按钮的内容 */}
            <IconFont type={`iconsanjiao-xia`} className={`yx-dropdown-icon ${visible ? 'yx-dropdown-icon-active': ''}`} iconfont={true}></IconFont>
        </div>
    }

    handleVisibleChange = flag => {
        this.setState({ visible: flag });
    };

    // 关闭弹窗
    closeMenu = (e) => {
        let keys = get(this.props,'unClosekeys',[])
        let nowKey = get(e,'key','')
        let res = keys.find((item) => item === nowKey);
        if(!nowKey || !res){
            this.setState({visible:false});
        }
    }


    render() {
        let content = get(this.props,'content',''); // content是下拉框弹窗的内容  接收antd的menu组件内容
        let isClickClose = get(this.props,'isClickClose',false);
        let inputParam = get(this.props,'inputParam',{}); // inputParam包含的内容是antd--DropDown组件接收的原参数，继承antd的属性
        content.props.className += " yx-default-menu-box";
        if(isClickClose){
            content.props.onClick = this.closeMenu;
        }
        return <Dropdown overlay={content} visible={this.state.visible} onVisibleChange={this.handleVisibleChange} {...inputParam}>
            {this.renderConent()}
        </Dropdown>
    }
}



// WEBPACK FOOTER //
// ./src/pages/Component/YxDropMenu/DropDown.js